import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { clearBrowserSessionCookies } from 'dashboard/store/utils/api';
import { validateLoggedInRoutes, LOGIN_URL } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';

const routes = [...dashboard.routes];

export const router = createRouter({ history: createWebHistory(), routes });

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    clearBrowserSessionCookies();
    window.location.assign(LOGIN_URL);
    return '';
  }

  if (!to.name) {
    return next(frontendURL(`accounts/${user.account_id}/dashboard`));
  }

  const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);

  // The login screen is not part of this router, it needs a full page load.
  // The session is dropped as well, otherwise the login guard sees the auth
  // cookie and bounces the user back here, looping between both screens.
  if (nextRoute === LOGIN_URL) {
    clearBrowserSessionCookies();
    window.location.assign(LOGIN_URL);
    return '';
  }

  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, _from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    userAuthentication.then(() => {
      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
